import React from 'react';
import Category from '@/components/category';

export default () => <Category />;
